import { render, staticRenderFns } from "./multi-inputbox.vue?vue&type=template&id=5af4d16a&scoped=true&"
import script from "./multi-inputbox.vue?vue&type=script&lang=js&"
export * from "./multi-inputbox.vue?vue&type=script&lang=js&"
import style0 from "./multi-inputbox.vue?vue&type=style&index=0&id=5af4d16a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af4d16a",
  null
  
)

export default component.exports